import type { PopoverOrigin } from '@mui/material'

export const TRANSFORM_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'center',
} as PopoverOrigin

export const ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'center',
} as PopoverOrigin

export const HEADER_BUTTON_TRANSFORM_ORIGIN = { vertical: 'top', horizontal: 'right' } as PopoverOrigin
export const HEADER_BUTTON_ANCHOR_ORIGIN = { vertical: 'bottom', horizontal: 'right' } as PopoverOrigin
